import styled from 'styled-components';
import colors from 'assets/styles/colors';
import SectionContainer from '../containers/SectionContainer';

export const ContributeDeviceContainer = styled(SectionContainer)`
  background-color: ${colors.pancho};
  display: flex;
  align-items: center;
`;
